import { Badge } from "@/shared/components/ui/badge";
import { DocumentStateBase } from "@/services/backend/documents/types/state";
import { documentStateLabel } from "@/services/backend/documents/lib/document-state";
import { DocumentStateIcon } from "@/shared/bsm/core/document/components/ui/document-state-icon";

/**
 * DocumentStateBadge shows the lifecycle state of a document. It is meant to
 * be placed next to the reference number of the document.
 */
export function DocumentStateBadge({
  document,
  className,
}: {
  document: DocumentStateBase;
  className?: string;
}) {
  return (
    <Badge variant="outline" className={className}>
      <DocumentStateIcon state={document.state} />
      {documentStateLabel(document.state)}
    </Badge>
  );
}
